import {
    FETCH_CLIENT_CREDENTIALS,
    FETCH_CLIENT_CREDENTIALS_FAIL,
    FETCH_CLIENT_CREDENTIALS_SUCCESS,
    SET_CLIENT_BRANDS,
    SET_CLIENT_BRANDS_FAIL,
    SET_CLIENT_BRANDS_SUCCESS
} from './actionTypes';

export const fetchClientCredentials = () => ({
    type: FETCH_CLIENT_CREDENTIALS
});

export const fetchClientCredentialsSuccess = response => ({
    type: FETCH_CLIENT_CREDENTIALS_SUCCESS,
    payload: response
});

export const fetchClientCredentialsFail = error => ({
    type: FETCH_CLIENT_CREDENTIALS_FAIL,
    payload: error
});

export const setClientBrands = ({ id, brandIds }) => ({
    type: SET_CLIENT_BRANDS,
    payload: { id, brandIds }
});

/* The credential as it is now, with its brands */
export const setClientBrandsSuccess = credential => ({
    type: SET_CLIENT_BRANDS_SUCCESS,
    payload: credential
});

export const setClientBrandsFail = ({ id, error }) => ({
    type: SET_CLIENT_BRANDS_FAIL,
    payload: { id, error }
});
